import React from 'react';
import { bool, func, number, string } from 'prop-types';

// Import components
import {
	Bg,
	BlackTransparentBackground,
	MobileWrapper,
	Box,
	ButtonClose,
	Content,
	GradientBox,
	GradientRadial,
	IconCloseStyled,
	Wrapper
} from './styles';
import { Loader } from 'components/elements';

// Import helpers
import usePaymentTemplate from './usePaymentTemplate';
import { children } from 'helpers/props';

function PaymentTemplate({ children, toggle, period, uuid, promotion }) {
	const { showLoader, isLoaded, handleClose, isMobile } = usePaymentTemplate({
		toggle,
		promotion,
		period,
		uuid
	});

	if (isMobile)
		return (
			<MobileWrapper id="payment_modal">
				<ButtonClose onClick={toggle}>
					<IconCloseStyled />
				</ButtonClose>
				{children}
			</MobileWrapper>
		);

	return (
		<Wrapper className="wrapper">
			{showLoader && (
				<BlackTransparentBackground zIndex={10}>
					<Loader position="absolute" />
				</BlackTransparentBackground>
			)}
			<Bg onClick={handleClose} />
			<GradientBox className="gradient">
				<Box className="content-box">
					{isLoaded && (
						<ButtonClose onClick={toggle}>
							<IconCloseStyled />
						</ButtonClose>
					)}
					<GradientRadial isLoaded={isLoaded} />
					<Content>{children}</Content>
				</Box>
			</GradientBox>
		</Wrapper>
	);
}

PaymentTemplate.propTypes = {
	children: children.isRequired,
	toggle: func,
	uuid: string.isRequired,
	period: number,
	promotion: bool
};

export default PaymentTemplate;
